import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface FlyingItem {
  id: string;
  startX: number;
  startY: number;
  imageUrl?: string;
}

interface FlyingCartAnimationProps {
  items: FlyingItem[];
  onComplete: (id: string) => void;
}

export const FlyingCartAnimation = ({ items, onComplete }: FlyingCartAnimationProps) => {
  const [cartPosition, setCartPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Find cart icon position in bottom nav
    const updateCartPosition = () => {
      const cartIcon = document.querySelector('[data-cart-icon="true"]');
      if (cartIcon) {
        const rect = cartIcon.getBoundingClientRect();
        setCartPosition({
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
        });
      }
    };

    updateCartPosition();
    window.addEventListener("resize", updateCartPosition);
    return () => window.removeEventListener("resize", updateCartPosition);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[100]">
      <AnimatePresence>
        {items.map((item) => (
          <motion.div
            key={item.id}
            initial={{
              x: item.startX,
              y: item.startY,
              scale: 1,
              opacity: 1,
            }}
            animate={{
              x: cartPosition.x - 20,
              y: cartPosition.y - 20,
              scale: 0.3,
              opacity: 0.8,
            }}
            exit={{
              scale: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.6,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            onAnimationComplete={() => onComplete(item.id)}
            className="absolute w-10 h-10 rounded-full bg-primary shadow-lg shadow-primary/50 flex items-center justify-center overflow-hidden"
          >
            {item.imageUrl ? (
              <img src={item.imageUrl} alt="" className="w-full h-full object-cover" />
            ) : (
              <span className="text-lg">🍽️</span>
            )}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
